import { render, staticRenderFns } from "./AddChaptersForm.vue?vue&type=template&id=696d2b30&scoped=true&"
import script from "./AddChaptersForm.vue?vue&type=script&lang=js&"
export * from "./AddChaptersForm.vue?vue&type=script&lang=js&"
import style0 from "./AddChaptersForm.vue?vue&type=style&index=0&id=696d2b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696d2b30",
  null
  
)

export default component.exports